// The brand ("persona") this page is served as. The server picks it from the request host
// (config/brands.yml) and writes it into <meta name="brand-config">; nothing here changes
// while the page is open, so components read it directly.

export type Brand = {
    key: string;
    name: string;
    wordmark: string;
    short_name?: string;
    logo: {icon?: string; image?: string};
    legal_entity: string;
    legal_address: string;
    colors: {dark: string; card: string; accent: string; secondary: string; glow: string; theme?: string};
    fonts: {sans: string; display: string; google?: string};
    hero: {dimensions: string[]; headline: string[]; subhead: string};
    footer: {blurb: string; services: string[]};
    social: Partial<Record<'instagram' | 'twitter' | 'linkedin' | 'github' | 'facebook', string>>;
    services?: string[];
    // Lumière Archive, the event photo gallery, on this brand's own gallery host.
    gallery?: {url: string; blurb: string};
};

const readBrand = (): Brand => {
    const raw = typeof document === 'undefined'
        ? null
        : document.querySelector<HTMLMetaElement>('meta[name="brand-config"]')?.content;
    if (!raw) throw new Error('Missing <meta name="brand-config">; the Rails layout should render it');
    return JSON.parse(raw) as Brand;
};

export const BRAND: Brand = readBrand();
